import { Schema, string, bool, isodate, array, number } from 'lib/schema';
import moment from 'moment';

function NewDate() {
  return new Date().toISOString();
}

function EmptyArray() {
  return [];
}

export default class Episode extends Schema {
  @string id = { default: null };

  @string channel = { default: null };

  @string show = { default: null, path: 'channel' };

  @isodate created = { default: NewDate };

  @isodate modified = { mutable: true, default: NewDate };

  @isodate publishedOn = { mutable: true, default: null, path: 'published' };

  @isodate publishDate = { mutable: true, default: null };

  @bool exclusive = { default: false };

  @string language = { mutable: true, default: 'sv' };

  @string image = { mutable: true, path: 'image.original', default: null };

  @array permalinks = { default: EmptyArray };

  @array tags = { mutable: true, default: EmptyArray };

  @array keywords = { mutable: true, default: EmptyArray };

  @array categories = { mutable: true, default: EmptyArray };

  @string name = { mutable: true, default: '' };

  @string description = { mutable: true, default: '' };

  @string rating = { mutable: true, default: 'no' };

  @array conditions = { mutable: true, default: EmptyArray, path: 'permissions' };

  // TODO: Figure out how we want to handle rss in the future. These
  //       really should not be part of the acast model and the same
  //       applies to the channel
  @string rssAuthor = { mutable: true, path: 'rss.author', default: null };

  @string rssSubtitle = { mutable: true, path: 'rss.subtitle', default: null };

  @string rssSummary = { mutable: true, path: 'rss.summary', default: null };

  @string rssLink = { mutable: true, path: 'rss.link', default: null };

  @string mediaURL = { mutable: true, path: 'rss.feedMediaUrl', default: null };

  @number contentLength = { mutable: true, path: 'rss.feedMediaContentLength', default: 0 };

  @string episodeType = { mutable: true, default: 'full' };

  @number seasonNumber = { mutable: true, default: null };

  @number episodeNumber = { mutable: true, default: null };

  get url() {
    return this.permalinks[0] || null;
  }

  get isDraft() {
    return this.publishedOn === null;
  }

  get isPublished() {
    return (
      !this.isDraft && this.publishDate !== null && moment(this.publishDate).isBefore(new Date())
    );
  }

  get isQueued() {
    return (
      !this.isDraft && this.publishDate !== null && moment(this.publishDate).isAfter(new Date())
    );
  }

  get isModified() {
    return (
      !this.isDraft &&
      (this.isPublished || this.isQueued) &&
      moment(this.publishedOn).isBefore(this.modified)
    );
  }
}
